import { ChangeEvent } from "react";
import "./searchbox.scss";

export interface SearchboxProps {
  onSearchChange: (value: string) => void;
  handleCloseClick: () => void;
  value?: string;
  placeholder?: string;
}

const Searchbox = ({
  onSearchChange,
  handleCloseClick,
  value,
  placeholder,
}: SearchboxProps) => {
  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    onSearchChange(event.target.value);

    if (window && (window as any)["ReactNativeWebView"]) {
      (window as any)["ReactNativeWebView"].postMessage(
        JSON.stringify({
          message: "eventLogForCountly",
          eventName: "Search Bar",
          eventSegment: {
            icerik: event.target.value,
          },
          actionType: "view",
        })
      );
    }
  };

  return (
    <label htmlFor="searchbar" className="searchbox">
      <input
        id="searchbar"
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={handleChange}
      />
      <div className="icons">
        <span className="icon icon-search"></span>
      </div>
    </label>
  );
};

export default Searchbox;
